import { useEffect, useRef } from 'react';
import { LocalStorageObserver } from '../service/LocalStorageObserver.service';

const useLocalStorageObserver = (key: string, callback: (newValue: string | null) => void) => {
  const callbackRef = useRef<(newValue: string | null) => void>(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    // @TODO : Class based implementation to be changed to ts util based
    const localStorageObserver = new LocalStorageObserver(key, callbackRef.current);

    // window.addEventListener('storage', handleStorageChange);

    return () => {
      // window.removeEventListener('storage', handleStorageChange);
      localStorageObserver.stopObserving();
    };
  }, [key]);
};

export default useLocalStorageObserver;
